import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-weave-table-edit',
    templateUrl: './weave-table-edit.component.html',
    styleUrls: ['./weave-table-edit.component.scss'],
    standalone: false
})
export class WeaveTableEditComponent implements OnInit {

  @Input() fields: tableEditField[];
  @Input() initialValues: any = [];
  @Input() rowLabels: rowLabel[];
  @Input() showErrors: boolean = false;
  @Input() required: boolean = false;
  @Output() valuesEmitter = new EventEmitter<any>();
  values: any;


  constructor() { }

  ngOnInit() {
    this.initTableValues();
  }

  emitValues(valueRow, propertyName, val){
    valueRow[propertyName] = val;
    this.valuesEmitter.emit(this.values);
  }

  initTableValues(){
    this.values = [];
    for(let rowLabel of this.rowLabels){
      let newRow = {};
      let rowValue = this.getRowByRowKey(rowLabel.key, this.initialValues);
      if(typeof rowValue !== "undefined"){
        for(let field of this.fields){
          let cellValue = rowValue.find(c => c.propertyName === field.propertyName);
          newRow[field.propertyName] = typeof cellValue !== "undefined" ? cellValue.answer : "";
        }
      }
      else{
        newRow[rowLabel.key] = "";
        for(let field of this.fields){
          newRow[field.propertyName] = "";
        }
      }
      this.values.push(newRow);
    }
  }

  getRowByRowKey(key: string, dataArr: any[][]){
    if(!dataArr){
      return undefined;
    }
    return dataArr.find((row) => {
      return row.filter(obj => { return obj.propertyName === key}).length > 0;
    })
  }

}


export interface tableEditField{
  label: string,
  type: string,
  placeholder: string,
  propertyName: string,
  required: boolean,
  selectValues?: {
    label: string,
    value: any
  }[]
}

interface rowLabel{
  key: string,
  content: string,
}
